<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>CREATE_NEW_PLANOGRAM</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.itemNo"
      gungTranslate="ITEM_NO"
      [renderStatic]="disableEdit"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.name"
      [renderStatic]="disableEdit"
      gungTranslate="NAME"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.assortmentId"
      [renderStatic]="disableEdit"
      gungTranslate="ASSORTMENT_ID"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-number-input-horizontal
      [(ngModel)]="planogram.width"
      [renderStatic]="isEdit"
      gungTranslate="WIDTH_MM"
    ></lib-gung-number-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-number-input-horizontal
      [(ngModel)]="planogram.widthStep"
      [renderStatic]="isEdit"
      gungTranslate="WIDTH_STEP"
    ></lib-gung-number-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-number-input-horizontal
      [(ngModel)]="planogram.shelfs"
      [renderStatic]="disableEdit"
      gungTranslate="SHELFS"
    ></lib-gung-number-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.furniture"
      [renderStatic]="disableEdit"
      gungTranslate="FURNITURE"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.customer"
      [renderStatic]="disableEdit"
      gungTranslate="CUSTOMER"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.country"
      [renderStatic]="disableEdit"
      gungTranslate="COUNTRY"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.year"
      [renderStatic]="disableEdit"
      gungTranslate="YEAR"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <lib-gung-text-input-horizontal
      [(ngModel)]="planogram.period"
      gungTranslate="PERIOD"
      [renderStatic]="disableEdit"
    ></lib-gung-text-input-horizontal>
  </div>
  <div class="col-12">
    <div><strong translate>ADDITIONAL_PRODUCTS</strong></div>
    <div *ngFor="let additionalProduct of additionalProducts; index as i" class="mb-2">
      <div class="row align-items-center">
        <div class="col-3 mb-0">
          <lib-gung-text-input-horizontal
            [(ngModel)]="additionalProduct.id"
            (ngModelChange)="onProductIdChange($event)"
            gungTranslate="ID"
            class="mb-0"
          ></lib-gung-text-input-horizontal>
        </div>
        <div class="col-4 d-flex align-items-center">
          <span class="text-muted">{{ productNames[additionalProduct.id] }}</span>
        </div>
        <div class="col-3 mb-0">
          <lib-gung-number-input-horizontal
            [(ngModel)]="additionalProduct.qty"
            gungTranslate="QTY"
            class="mb-0"
          ></lib-gung-number-input-horizontal>
        </div>
        @if (!disableEdit) {
          <div class="col-2 text-right">
            <button class="btn btn-outline-secondary" (click)="removeAdditionalProduct(i)">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        }
      </div>
    </div>
    @if (!disableEdit) {
      <button class="btn btn-sm btn-outline-secondary" (click)="addAdditionalProduct()" translate>
        ADD_ADDITIONAL_PRODUCT
      </button>
    }
  </div>
  <div class="col-12 mt-3">
    <div><strong translate>EXPIRED_MODULES</strong></div>
    <div class="removed-list">
      <div class="removed-modules" *ngFor="let item of this.planogram.expiredAndRemovedItems">
        <span class="mr-2">{{ item }}</span>
        @if (!disableEdit) {
          <span (click)="removeExpired(item)"> <i class="fas fa-times"></i></span>
        }
      </div>
    </div>
  </div>
  <div class="col-12 mt-3">
    <div><strong translate>KEEP_MODULES</strong></div>
    <div class="removed-list">
      <div class="removed-modules" *ngFor="let item of this.planogram.keepModuleItems">
        <span class="mr-2">{{ item }}</span>
        @if (!disableEdit) {
          <span (click)="removeKeep(item)"> <i class="fas fa-times"></i></span>
        }
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group btn-group-justified w-100">
    <button class="btn btn-secondary" (click)="cancel()" translate>CANCEL</button>
    @if (!disableEdit) {
      <button class="btn btn-primary" (click)="confirm()" translate>OK</button>
    }
  </div>
</div>
